<form [formGroup]="form" (submit)="onSubmitForm()">
  <div class="block block-rounded block-themed">
    <div class="block-header bg-gd-primary">
      <h3 class="block-title">Payment Settings</h3>
      <div class="block-options">
        <button type="submit" class="btn btn-sm btn-alt-primary" (click)="onSubmitForm()"
                [disabled]="housing == null || isLoading === true">
          <i class="fa fa-save mr-5" *ngIf="isLoading === false"></i>
          <i class="fa fa-cog fa-spin mr-5" *ngIf="isLoading === true"></i>Save
        </button>
      </div>
    </div>
    <div class="block-content block-content-full">
      <div class="form-group row">
        <label class="col-4">Enable Payment</label>
        <div class="col-8">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="housing-enable-payment" name="isPaymentEnabled"
                   formControlName="isPaymentEnabled">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4">100% Partner Payout</label>
        <div class="col-8">
          <label class="css-control css-control-success css-switch">
            <input type="checkbox" class="css-control-input" id="housing-enable-payment" name="hundredPercentPayouts"
                   formControlName="hundredPercentPayouts">
            <span class="css-control-indicator"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
<!-- END Sauce -->
